import { setProps } from '../props';
import initialize from '../Services/initialize';

export default (props: any) => (dispatch) => {

  setProps(props);

  dispatch(initialize());

    
}